import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Api } from '../_models/index';
import { CustomerService } from '../_services/index';


@Component({
    selector: 'configuration',
    templateUrl: './api.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})
export class ApiComponent implements OnInit {
    apiForm: FormGroup;
    randomAPI: any;
    public customer_public_id: string;
    statusresult: any;
    isalertVisiable = false;

    /**
 * constructor function is used to initialize 
 */
    constructor(

        private _fb: FormBuilder
        , private router: Router
        , private route: ActivatedRoute,
        private customerservice: CustomerService
    ) {

        this.InitialSetup();

    }

    InitialSetup() {




        this.apiForm = this._fb.group({
            value: new FormControl(""),


        });
    }
    ngOnInit() {


        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');

            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');

        }
        this.GetCustomerApiDetails();
    }




    /* To copy Text from Textbox */
    copyInputMessage(inputElement) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.setTooltip('Copied!');




    }
    setTooltip(message) {
        $('#idTool').tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    }



    generate_random_string(string_length) {
        let random_string = '';
        let random_ascii;
        let ascii_low = 0;
        let ascii_high = 99;
        for (let i = 0; i < string_length; i++) {
            random_ascii = Math.floor((Math.random() * (ascii_high - ascii_low)) + ascii_low);


            random_string += String.fromCharCode(random_ascii)
            this.randomAPI = btoa(random_string += String.fromCharCode(random_ascii))

        }
        return random_string;
    }

    GetCustomerApiDetails() {
        this.customerservice.getApiDetails(this.customer_public_id).subscribe(data => {
            setTimeout(() => {
                this.apiForm = this._fb.group({
                    value: new FormControl(data.value)

                });
            }, 500)

        },
            error => {

                console.log('Failed while trying to the Customer Search All Result. ' + error);
            });



    }//end

    onsubmit(event, { value }: { value: Api }) {
        this.customerservice.updateAPI(value, this.customer_public_id)
            .subscribe((result) => {
                this.statusresult = "La información fue grabada correctamente !";
                this.isalertVisiable = true;
            },
                error => {
                    

                    this.isalertVisiable = true;
                    console.log('Failed while trying to update the API Details.' + error);
                }

            );
    }
}